module.exports = __webpack_public_path__ + "static/media/BankingApplications.022286ba.jpg";